module.exports = __webpack_public_path__ + "img/back.1c40b43a.jpg";